import { AfterViewInit, Component, HostListener, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, NavigationEnd, ParamMap, Router } from '@angular/router';
import { Subscription, tap } from 'rxjs';
import { Location, ViewportScroller } from '@angular/common';
import { HelpersService } from '../../../services/helpers.service';
import { NodeService } from '../../../services/node.services';
import { Breadcrumb, DataLayer, NewTag, Subtree, TranslationPath } from '../../../models/node';
import { CookieService } from 'ngx-cookie';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.scss']
})
export class NodeComponent implements AfterViewInit, OnDestroy, OnInit {

  @ViewChild('modalLogin') modalLogin: any;
  public url: any;
  public node: any;
  public translationPath: any;
  public waitNode = true;
  public onChangeLang$: Subscription = new Subscription();
  public onChangeRouteNode$: Subscription = new Subscription();
  public arrMetaOg: any;
  public hrefLang: NewTag = {} as NewTag;
  public hrefLangAlternate: NewTag = {} as NewTag;
  public hrefCanonical: NewTag = {} as NewTag;
  public noIndexTag: NewTag = {} as NewTag;
  public window: any;
  public levelMenu: Subtree[] = [];
  public levelMenuOther: Subtree[] = [];
  public isOpenMenu: boolean = false;
  public isPreviewMode: boolean = false;
  public eliminaVisualizzazione: boolean = false;
  public isShow: boolean = false;
  public isOpenMobileLocalMenu: boolean = false;
  private topPosToStartShowing = 100;
  public isShowLocalMenu: boolean = false;
  public isSecondLevelUp: boolean = false;
  public statusError: number | null = null;
  private isAvviso = false;
  public showLumiaChat = false;

  constructor(private nodeService: NodeService,
    private helpersService: HelpersService,
    private location: Location,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private cookieService: CookieService,
    private modalService: NgbModal,
    private scroller: ViewportScroller
  ) { }

  ngOnInit(): void {
    if (this.onChangeRouteNode$) {
      this.onChangeRouteNode$.unsubscribe();
    }
    this.onChangeRouteNode$ = this.router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.helpersService.openLocalMenuBS.next(false);
        this.helpersService.menuIsOpen.next(false);
        if (this.router.url !== this.url && !this.router.url.includes('#')) {
          this.initComponent();
          // this.router.navigated = false;
        }
      }
    });
    if (!this.url) {
      this.initComponent();
    }
  }
  
  ngAfterViewInit(): void {
    this.helpersService.menuIsOpen.subscribe(value => this.isOpenMenu = value);
    this.window = this.helpersService.getWindow();
    if (this.helpersService.isBrowser && this.node) {
      document.documentElement.lang = this.window.frames.location.pathname.split('/')[1]; 
    }
    this.checkMobileLocalMenu();
  }

  ngOnDestroy(): void {
    if (this.onChangeLang$ instanceof Subscription) {
      this.onChangeLang$.unsubscribe();
    }
    if (this.onChangeRouteNode$) {
      this.onChangeRouteNode$.unsubscribe();
    }
  }

  private initComponent() {
    
    const paramPreviewMode = this.activatedRoute.snapshot.queryParamMap.get('content-preview-page');
    if (paramPreviewMode) {
      this.isPreviewMode = true;
      if (this.cookieService.get(this.helpersService.cookieAccessTokenAdminKey)) {
        localStorage.setItem(this.helpersService.storageAccessTokenAdminKey, this.cookieService.get(this.helpersService.cookieAccessTokenAdminKey));
        this.getNode(this.getRouterSplitted());
      } else {
        if (this.helpersService.isBrowser) {
          this.modalService.open(this.modalLogin, { centered: true, size: 'lg' });
        }
      }
    } else {
      this.isPreviewMode = false;
      this.getNode(this.getRouterSplitted());
    }
    this.checkFragment();  

         
    if (this.onChangeLang$) {
      this.onChangeLang$.unsubscribe();
    }
    this.onChangeLang$ = this.helpersService.onChangeLang.subscribe(langCode => {
      //Imposto l'attributo lang nel tag html
      if (langCode) {
        document.documentElement.lang = langCode;
      }
      this.recreateNodeLang(langCode, this.node.nid[0].value);
    })
  }

  private checkFragment () {
    this.activatedRoute.fragment.subscribe((fragment: any) => {
      if (fragment && this.helpersService.isBrowser) {
        let countInterval: number = 0;
        let intervalfragment = setInterval(() => {
          const element = document.getElementById(fragment);
          if (element) {
            this.scroller.scrollToAnchor(fragment);
            this.scroller.setOffset([0, 380]);
            clearInterval(intervalfragment);
          }
          if (countInterval < 50) {
            countInterval += 1;
          } else {
            clearInterval(intervalfragment);
          }
        }, 200);
      }
    });
  }

  private getRouterSplitted(): string {
    var cloneRouterUrl = (' ' + this.router.url).slice(1);
    return cloneRouterUrl.split('?').length > 0 ? cloneRouterUrl.split('?')[0] : cloneRouterUrl;
  }

  public onLoggedAdmin(accessToken: any) {
    this.cookieService.put(this.helpersService.cookieAccessTokenAdminKey, accessToken, { domain: 'localhost' || environment.ulrApiPreview });
    localStorage.setItem(this.helpersService.storageAccessTokenAdminKey, accessToken);
    this.modalService.dismissAll();
    this.getNode(this.getRouterSplitted());
  }

  private getNode(url: string) {
    this.isAvviso = false;
    const checkUrlAvviso = "/newsroom/avvisi/";
    if (url.indexOf(checkUrlAvviso) >= 0) {
      this.isAvviso = true;
    }
    this.isSecondLevelUp = false;
    this.levelMenu = [];
    this.url = url;
    let anchor: string = '';
    for (let lang of this.helpersService.languages) {
      if (this.url === `/${lang.codeApi}`) {
        this.url = this.url + '/' + this.helpersService.routeHome;
      }
    }
    if (this.url.includes('#')) {
      anchor = this.url.split('#')[1];
      this.url = this.url.split('#')[0];
    }
    if (this.url && this.url.length && this.url.length > 6) {
      const lastCharsUrl = this.url.slice(-6);
      if (lastCharsUrl.indexOf(".") >= 0) {
        this.statusError = 404;
        if (!this.nodeService.isBrowser) console.log(url + ': KO FILE ');
        return;
      }
    }
    this.waitNode = true;
    this.statusError = null;
    this.nodeService.getNode(this.url, this.isPreviewMode).subscribe({
    next: (response: any) => {
      let res = response?.body;
      if (!res) {
        res = response;
      }
      this.node = {
        ...res,
        preview: this.isPreviewMode
      };

      
      if(url === "/it/segreteria-studenti-rm-pa-ta"){
        this.showLumiaChat = true;
      } else {
        this.showLumiaChat = false;
      }
      
      if(!this.isPreviewMode && this.node && !this.node?.status[0]?.value){
        this.router.navigateByUrl('/error/404')
      }

      if (this.node && this.node.changed && this.node.changed[0] && this.node.changed[0].value) {
        this.nodeService.nodeVersionTS = this.helpersService.convertDateToTimestamp(this.node.changed[0].value);
      }

      if (!this.helpersService.isBrowser && this.node.field_layout_righe && this.node.field_layout_righe.length) {
        this.node.field_layout_righe = this.node.field_layout_righe.slice(0,1);
      }

      if (response.url) {
        let originalUrl = (' ' + response.url).slice(1);
        let urlNew = response.url;
        urlNew = urlNew.split('?')[0];
        urlNew = urlNew.replace(/^.*\/\/[^\/]+/, '');
        urlNew = urlNew.replace('/local-proxy','');
        let currentUrl = this.router.url;
        currentUrl = currentUrl.split('?')[0];
        if (urlNew != currentUrl) {
          originalUrl = originalUrl.replace(/^.*\/\/[^\/]+/, '');
          originalUrl = originalUrl.replace('&_format=json','');
          originalUrl = originalUrl.replace('?_format=json','');
          this.location.replaceState(originalUrl);
        }
      }
      if (res.field_elimina_visualizzazione_vi && res.field_elimina_visualizzazione_vi.length) {
        this.eliminaVisualizzazione = res.field_elimina_visualizzazione_vi[0].value;
      }
      if(res.metatag && res.metatag.length){
        const title = res.metatag.filter((tag :any) => tag?.attributes?.name === 'title')[0]?.attributes?.content;
        this.nodeService.setTitle(title);
      } else if (res.title && res.title.length) {
        this.nodeService.setTitle(res.title[0].value);
      }
      // if (res.metatag && res.metatag.value) {
      //   this.nodeService.setTitle(res.metatag.value.title);
      // } else if (res.field_titolo && res.field_titolo.length) {
      //   this.nodeService.setTitle(res.field_titolo[0].value);
      // }

      this.setDataLayer(res);
      if (res.metatag && res.metatag.length) {
        this.helpersService.setMeta(res.metatag);
      } else if (res.title && res.title.length) {
        let tmpRes = [{
          attributes: {
            name: 'title',
            content: res.title[0].value
          }
        }]
        this.helpersService.setMeta(tmpRes);
      }
      const lang = res.path && res.path.length ? res.path[0].langcode : res.langcode && res.langcode.length ? res.langcode[0].value : '';
      this.setNewTag(lang);
      this.setNewTagAlternate(lang, this.node.nid[0].value);
      if (this.node.type[0].target_id !== 'corso_di_studi') {
        this.generateBreadcrumbs(res);
      }
      this.helpersService.nodeType = this.node.type[0].target_id;
      this.checkAHref();
      // if (!this.nodeService.isBrowser) console.log(url + ': OK');
      this.waitNode = false;

    
    },
    error: (err: any) => {
      this.waitNode = false;

      if (this.isAvviso && err.status === 404) {
        const urlHome = `/${this.helpersService.langCodeApi}/${this.helpersService.routeHome}`
        this.router.navigateByUrl(urlHome);
        return;
      }

      if (!this.nodeService.isBrowser) console.log(url + ': KO ' + err.status);
      if (err.status === 0 || err.status === 404 || err.status === 200) {
        err.status = 404;
        this.statusError = 404;
      } else {
        this.statusError = err.status;
      }
    }
  });
  }

  private checkAHref(){
    if(this.helpersService.isBrowser) {
      if (window.location.host !=  "lumsa-stag.mashfrog.com") {
        setTimeout(() => {
          document.querySelectorAll("a").forEach((anchor) => {
            if (anchor.href.indexOf("https://lumsa-stag.mashfrog.com") >= 0) {
              anchor.addEventListener('click', (event: any) => {
                event.preventDefault();
                let element = event.srcElement;
                if (element.tagName != "A" && element.parentElement.tagName == "A") {
                  element = element.parentElement;
                }
                if (element && element.host === "lumsa-stag.mashfrog.com") {
                  event.preventDefault();
                  this.router.navigateByUrl(element.pathname);
                }
              }, false);
            }
          })
        }, 1000)
      }
    }
  }


  private generateBreadcrumbs(res: any): void {
    this.levelMenu = [];
    if (this.nodeService.header && this.nodeService.header.field_main_menu.length && res.title[0].value !== 'Homepage') {
      const levelMenu = this.nodeService.getTreeFromPath(this.url, this.nodeService.header.field_main_menu);
      if (levelMenu && levelMenu.length) {
        this.isSecondLevelUp = this.nodeService.getPageLevel(this.url, this.nodeService.header.field_main_menu) > 1;
        this.levelMenu = JSON.parse(JSON.stringify(levelMenu));
      } else {
        this.levelMenuOther = this.generateBreadcrumbsSecondaria(this.nodeService.header.field_barra_secondaria, this.url);
        this.isSecondLevelUp = this.levelMenuOther.length > 1;
      }
    }
    if (this.levelMenuOther && !this.levelMenuOther.length) {
      const label = this.generateBreadcrumbLabel(this.url);
      this.levelMenuOther = [{ label: label, url: this.url } as any];
    }
  }

  private generateBreadcrumbLabel(url: string): string {
    const parts = url.split('/');
    let label = parts[parts.length - 1].replace(/-/g, ' ');
    label = label.charAt(0).toUpperCase() + label.slice(1);
    return label;
  }

  private generateBreadcrumbsSecondaria(data: any[], url: string): any[] {
    const breadcrumbs: Breadcrumb[] = [];
    // Loop through all the objects in the data array
    for (const element of data) {
      let fieldTitoloElementoUrl = '';
      // Loop through all the columns and links in the field_colonne_menu array and add the breadcrumbs
      for (const column of element.field_colonne_menu) {
        for (const link of column.field_link_colonna || []) {
          if (link.url === url) {
            // Push the field_titolo_elemento value as the first breadcrumb label (if it exists and matches the URL)
            const fieldTitoloElemento = element.field_titolo_elemento?.[0]?.value;
            if (fieldTitoloElemento && fieldTitoloElementoUrl === '') {
              const parts = url.split("/");
              const penultimateIndex = parts.length - 2;
              const penultimate = parts.slice(0, penultimateIndex).join("/") + '/' + parts[penultimateIndex];
              fieldTitoloElementoUrl = element.field_titolo_elemento?.[0]?.url ?? penultimate;
              breadcrumbs.push({ label: fieldTitoloElemento, url: fieldTitoloElementoUrl });
            }
            // Create a new breadcrumb with the label and URL of the matching link
            let label = link.label;
            if (label.toLowerCase() === 'scopri') {
              const parts = link.url.split('/');
              label = parts[parts.length - 1].replace(/-/g, ' ');
              label = label.charAt(0).toUpperCase() + label.slice(1);
            }
            breadcrumbs.push({ label, url: link.url });
            return breadcrumbs;
          }
        }
      }
    }
    return breadcrumbs;
  }

  private setNewTag(langcode: string) {
    let absoluteurl = this.window.frames.location.href;
    absoluteurl = absoluteurl.replace("http:", "https:");
    absoluteurl = absoluteurl.split("?")[0];
    this.hrefCanonical = {
      nameTag: 'link',
      attributes: [
        {
          nameAttribute: 'rel',
          value: 'canonical'
        },
        {
          nameAttribute: 'href',
          value: absoluteurl
        },
        {
          nameAttribute: 'id',
          value: 'hrefCanonical'
        }
      ],
      idTag: 'hrefCanonical'
    };
    this.hrefLang = {
      nameTag: 'link',
      attributes: [
        {
          nameAttribute: 'rel',
          value: 'alternate'
        },
        {
          nameAttribute: 'hreflang',
          value: langcode
        },
        {
          nameAttribute: 'href',
          value: absoluteurl
        },
        {
          nameAttribute: 'id',
          value: 'hrefLang'
        }
      ],
      idTag: 'hrefLang'
    };
    this.helpersService.createHtmlTag(this.hrefLang, 'head');
    this.helpersService.createHtmlTag(this.hrefCanonical, 'head');
  }

  private setNewTagAlternate(path: any, nid: number) {
    this.nodeService.getTranslationPath(path, nid).subscribe((res: TranslationPath[]) => {
      if (res) {
        res.forEach(lang => {
          const langCode = lang.Langcode;
          let currentUrl = `${this.window.frames.location.origin}${lang.Path}`;
          currentUrl = currentUrl.replace("http:", "https:");        
          currentUrl = currentUrl.split("?")[0];
          if(langCode !== path){
            this.hrefLangAlternate = {
              nameTag: 'link',
              attributes: [
                {
                  nameAttribute: 'rel',
                  value: 'alternate'
                },
                {
                  nameAttribute: 'hreflang',
                  value: langCode
                },
                {
                  nameAttribute: 'href',
                  value: currentUrl
                },
                {
                  nameAttribute: 'id',
                  value: 'hrefLangAlternate' + langCode
                }
              ],
              idTag: 'hrefLangAlternate'
            };
            this.helpersService.createHtmlTag(this.hrefLangAlternate, 'head');
          }
          

        })
      }
    })
  }

  private setDataLayer(node: any) {
    const dataLayer: DataLayer = {
      event: 'pageView',
      location: this.window.frames.location.origin,
      pagePath: this.window.frames.location.pathname,
      pageTitle: node.metatag && node.metatag.value ? node.metatag.value.title : 
                 node.field_titolo && node.field_titolo.length ? node.field_titolo[0].value : '',
      pageType: node.type[0].target_id
    }
    this.window.dataLayer = this.window.dataLayer || [];
    this.window.dataLayer.push(dataLayer);
  }

  private recreateNodeLang(lang: string, nid: number) {
    this.nodeService.getTranslationPath(lang, nid).subscribe((res: TranslationPath[]) => {
      if (res) {
        let existLang = false;
        res.forEach(language => {
          if(language.Langcode == lang){
            existLang = true;
            this.translationPath = language.Path;
            this.getNode(this.translationPath);
            this.location.replaceState(this.translationPath);
          } 
        })
        if (!existLang){
          this.helpersService.goToHomeLang();
        }
      } else {
        this.helpersService.goToHomeLang();
      }
    }, err => {
      this.nodeService.showError(err);
    })
  }

  public closeHeader() {
    this.helpersService.menuHeaderOpenBS.next(false);
    this.helpersService.menuHeaderClickedIdBS.next("");
  }

  //SCROLL TOP
  private checkMobileLocalMenu(): void {
    this.helpersService.scrollOnTopBS.subscribe(isOpen => {
      this.isOpenMobileLocalMenu = isOpen;
    });
  }

  @HostListener('window:scroll')
  checkScroll() {
    const scrollPosition = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  public scrollOnTop(): void {
    this.scroller.scrollToPosition([0, 0]);
  }

}
